import { render } from "./RenewEnrollmentPage.vue?vue&type=template&id=00a95a05&scoped=true&ts=true"
import script from "./RenewEnrollmentPage.vue?vue&type=script&lang=ts"
export * from "./RenewEnrollmentPage.vue?vue&type=script&lang=ts"

import "./RenewEnrollmentPage.vue?vue&type=style&index=0&id=00a95a05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a95a05"]])

export default __exports__